<div>
  <h2 id="retirementPlanDocumentsHeader">Retirement Plan Documents</h2>
  <hr />
  <app-dismissible-alert [pageId]="'RetirementPlanDocuments'" [isGlobal]="false"></app-dismissible-alert>
  <span>{{pageIntro}}</span>
  <br /><br />

  <div class="panel panel-body">
    <app-pending-acknowledgements
      [managedContent]="retirementPlanDocumentsManagedContent"
      (docAcknowledgedEvent)="docAcknowledged($event)">
    </app-pending-acknowledgements>
  </div>
  <div class="panel panel-body">
    <h4>Retirement Plan Documents</h4>
    <span *ngIf="documentsLoading" class="pull-right spinner"></span>
    <br />
    <div *ngIf="!documentsLoading" class="dismissibleAlert information bodytext">{{manualUploadExplanation}}</div>
    <ng-container *ngFor='let organization of organizations; index as i'>
      <br />
      <div class="row">
        <label style="margin-top:6px;">{{organization.Name}}</label>
        <div class="pull-right">
          <a class="btn btn-link" style="cursor:pointer;" routerLink="" (click)="closeOthers(i,true)">Expand All</a>
          <span>&nbsp;&#124;</span>
          <a class="btn btn-link pull-right" style="cursor:pointer;" routerLink="" (click)="closeOthers(i,false)">Collapse All</a>
        </div>
      </div>
      <div *ngIf='collectionsForSorting["safeharborssorted" + i].length > 0'>
        <div class="compact">
          <div class="panel-group">
            <div class="accordion">
              <div class="accordion-heading">
                <h4 class="accordion-title">
                  <a class="accordion-toggle" (click)="toggle('safeharborssorted' + i)"
                    *ngIf="this.collectionsForSorting['safeharborssorted' + i].length">
                    <span
                      [ngClass]="{'glyphicon-minus':isOpen['safeharborssorted' + i] , 'glyphicon-plus':!isOpen['safeharborssorted' + i]}"
                      class="glyphicon collapse-button"></span>
                    <span>Safe Harbor</span>
                  </a>
                </h4>
              </div>
              <div *ngIf="isOpen['safeharborssorted' + i]" class="accordion-body">
                <table class="table" style="margin-bottom:0px;" matSort
                  (matSortChange)='sortDataSafeHarborDocuments($event, i)' matSortActive="Name" matSortDirection="asc"
                  matSortDisableClear=true>
                  <thead>
                    <tr>
                      <th mat-sort-header='Name' style="width:32%;">PLAN DOCUMENT</th>
                      <th mat-sort-header='EffectiveDate' style="width:33%;">EFFECTIVE DATE</th>
                      <th mat-sort-header='ReleaseDate' style="width:33%;">RELEASE DATE</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor='let element of collectionsForSorting["safeharborssorted" + i]'>
                      <tr>
                        <td><a href='{{element.Name}}'>{{element.Type}}</a></td>
                        <td>{{element.EffectiveDate}}</td>
                        <td>{{element.ReleaseDate}}</td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf='this.collectionsForSorting["adoptionagreementssorted" + i].length > 0'>
        <div class="compact">
          <div class="panel-group">
            <div class="accordion">
              <div class="accordion-heading">
                <h4 class="accordion-title">
                  <a class="accordion-toggle" (click)="toggle('adoptionagreementssorted' + i)"
                    *ngIf="this.collectionsForSorting['adoptionagreementssorted' + i].length">
                    <span
                      [ngClass]="{'glyphicon-minus':isOpen['adoptionagreementssorted' + i] , 'glyphicon-plus':!isOpen['adoptionagreementssorted' + i]}"
                      class="glyphicon collapse-button"></span>
                    <span>Adoption Agreements</span>
                  </a>
                </h4>
              </div>
              <div *ngIf="isOpen['adoptionagreementssorted' + i]" class="accordion-body">
                <table class="table" style="margin-bottom:0px;" matSort
                  (matSortChange)='sortDataAdoptionAgreements($event, i)' matSortActive="PlanDocument"
                  matSortDirection="asc" matSortDisableClear=true>
                  <thead>
                    <tr>
                      <th mat-sort-header='PlanDocument'>PLAN DOCUMENT</th>
                      <th mat-sort-header='DocumentType'>DOCUMENT TYPE</th>
                      <th mat-sort-header='EffectiveDateDisplay'>EFFECTIVE DATE</th>
                      <th mat-sort-header='PlanNumber'>PLAN NUMBER</th>
                      <th>STATUS</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor='let element of collectionsForSorting["adoptionagreementssorted" + i]'>
                      <tr>
                        <td style="width:19%;">
                          <a href="{{element.DownloadLink}}" target="_blank" *ngIf="element.CanDownload">
                            {{element.PlanDocument}}</a>
                          <span *ngIf="!element.CanDownload" class="graytext">{{element.PlanDocument}}</span>
                          <ng-container *ngIf="element.AddendumsVisible">
                            <div class="addendumInfo" *ngFor="let addendum of element.Addendums" ,
                              ngStyle="{'marginLeft':'25px'}">
                              <a href="{{addendum.FileName}}" target="_blank"
                                *ngIf="addendum.CanDownload">{{addendum.PlanDocument}}</a>
                              <span class="graytext" *ngIf="!addendum.CanDownload"> {{addendum.PlanDocument}}
                              </span>
                            </div>
                          </ng-container>
                        </td>
                        <td style="width:21%;">{{element.DocumentType}}
                          <ng-container *ngIf="element.AddendumsVisible">
                            <div class="addendumInfo" *ngFor="let addendum of element.Addendums">
                              {{addendum.DocumentType}}
                            </div>
                          </ng-container>
                        </td>
                        <td style="width:21%;">{{element.EffectiveDateDisplay}}
                          <ng-container *ngIf="element.AddendumsVisible">
                            <div class="addendumInfo" *ngFor="let addendum of element.Addendums">
                              {{addendum.EffectiveDateDisplay}}
                            </div>
                          </ng-container>
                        </td>
                        <td style="width:20%;">{{element.PlanNumber}}
                          <ng-container *ngIf="element.AddendumsVisible">
                            <div class="addendumInfo" *ngFor="let addendum of element.Addendums">
                              {{addendum.PlanNumber}}
                            </div>
                          </ng-container>
                        </td>
                        <td style="width:19%;" class="italic">{{element.Status}}
                          <ng-container *ngIf="element.AddendumsVisible">
                            <div class="addendumInfo" *ngFor="let addendum of element.Addendums">{{addendum.Status}}
                            </div>
                          </ng-container>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf='collectionsForSorting["retirementspdssorted" + i].length > 0'>
        <div class="compact">
          <div class="panel-group">
            <div class="accordion">
              <div class="accordion-heading">
                <h4 class="accordion-title">
                  <a class="accordion-toggle" (click)="toggle('retirementspdssorted' + i)"
                    *ngIf="this.collectionsForSorting['retirementspdssorted' + i].length">
                    <span
                      [ngClass]="{'glyphicon-minus':isOpen['retirementspdssorted' + i] , 'glyphicon-plus':!isOpen['retirementspdssorted' + i]}"
                      class="glyphicon collapse-button"></span>
                    <span>Summary Plan Description (SPD)</span>
                  </a>
                </h4>
              </div>
              <div *ngIf="isOpen['retirementspdssorted' + i]" class="accordion-body">
                <table class="table" style="margin-bottom:0px;" matSort
                  (matSortChange)='sortDataRetirementSpds($event, i)' matSortActive="PlanDocument"
                  matSortDirection="asc" matSortDisableClear=true>
                  <thead>
                    <tr>
                      <th style="width:61%;" mat-sort-header='PlanDocument'>PLAN DOCUMENT</th>
                      <th mat-sort-header='EffectiveDateDisplay'>EFFECTIVE DATE</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor='let element of collectionsForSorting["retirementspdssorted" + i]'>
                      <tr>
                        <td *ngIf="element.Smms.length > 0">
                          <a class="accordion-toggle" (click)="element.SmmsVisible = !element.SmmsVisible">
                            <span
                              [ngClass]="{'glyphicon-minus':element.SmmsVisible, 'glyphicon-plus':!element.SmmsVisible}"
                              class="glyphicon collapse-button"></span></a>
                          <span [innerHtml]="element.PlanDocument"></span>
                        </td>
                        <td *ngIf="element.Smms.length == 0">
                          <span [innerHtml]="element.PlanDocument"></span>
                        </td>
                        <td>{{element.EffectiveDateDisplay}}</td>
                      </tr>
                      <ng-container
                        *ngIf="element.Smms.length > 0 && element.SmmsVisible && isOpen['retirementspdssorted' + i]">
                        <ng-container *ngFor="let smm of element.Smms">
                          <tr>
                            <td>
                              <div class="addendumInfo" style="margin-left:50px"
                                *ngIf="element.SmmsVisible  && isOpen['retirementspdssorted' + i]">
                                <span [innerHtml]="smm.PlanDocument"></span>
                              </div>
                            </td>
                            <td>
                              <div class="addendumInfo"
                                *ngIf="element.SmmsVisible && isOpen['retirementspdssorted' + i]">
                                <span>{{smm.EffectiveDate | date:'M/d/yyyy'}}</span>
                              </div>
                            </td>
                          </tr>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="panel panel-body">
    <h4>Acknowledged Distributions</h4>
    <span *ngIf="documentsLoading" class="pull-right spinner"></span>
    <table class="table" *ngIf='processedDistributionsLength > 0' matSort
      (matSortChange)='sortDataProcessedDistributions($event)' matSortActive="Organization" matSortDirection="asc"
      matSortDisableClear=true>
      <thead>
        <tr>
          <th mat-sort-header='Organization'>SUBGROUP</th>
          <th mat-sort-header='PlanDocument'>PLAN DOCUMENT</th>
          <th mat-sort-header='Type'>DOCUMENT TYPE</th>
          <th mat-sort-header='EffectiveDateDisplay'>EFFECTIVE DATE</th>
          <th>STATUS</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor='let element of processedDistributionsSorted'>
          <tr class="active">
            <td>{{element.Organization}}</td>
            <td>{{element.PlanDocument}}</td>
            <td>{{element.Type}}</td>
            <td>{{element.EffectiveDateDisplay}}</td>
            <td><button (click)="element.Expanded = !element.Expanded;" *ngIf="!element.Expanded"
                class="btn btn-sm btn-link">Sent</button>
              <a *ngIf="element.Expanded"
                href="/#/admin/retirement-plan-documents/print-distribution/{{element.RetirementSpdId}}"
                class=" btn btn-link"><span class="glyphicon glyphicon-print"></span></a>
            </td>
          </tr>
          <tr *ngIf="element.Expanded">
            <td colspan="5">
              <h4 class="confirmation-message">
                <span class="glyphicon glyphicon-ok-sign text-success pull-left"></span>
                <span class="text-success">Your distribution acknowledgment was successfully submitted on {{element.SubmissionDate}} by {{element.SubmittedByFullName}}.</span>
              </h4>
              <div class="vspacer vspacer-large"></div>
              <div style="padding-bottom:10px;">
                <div>Date Distributed: {{ element.DistributionDate | date:'MM/dd/yyyy'}}</div>
                <div>Your Method of Distribution: {{element.DistributionMethod}}</div>
                <div>Comments: {{element.Comments? element.Comments: 'N/A'}} </div>
                <br>
                <div *ngIf='element.ParticipantNumber > 0'>
                  <h5>NON-ENGLISH LANGUAGE SURVEY</h5>
                  <div *ngIf="element.FewerThan100Participants && element.ParticipantNumber < 100">
                    <b>Plans with fewer than 100 participants</b>
                    <div>Are 25% or more of all plan participants only literate in a non-English language?
                      {{element.English25Percent? 'Yes' : 'No'}} </div>
                    <div
                      *ngIf="!element.English25Percent && (!element.moreThan100Participants || (element.MoreThan100Participants && element.English500))">
                      A non-English survey is not required.</div>
                    <div *ngIf="element.English25Percent">
                      <div>Total number of plan participants who read only the same non-English language:
                        {{element.NumParticipantsLesser}}</div>
                      <div>What is the non-English language? {{element.NonEnglishLanguageLesser}} </div>
                    </div>
                  </div>
                  <br>
                  <div *ngIf='element.MoreThan100Participants && element.ParticipantNumber > 99'>
                    <strong> Plans with 100 or more participants</strong>
                    <div>Are 500 or more of your plan participants literate only in a non-English language?
                      {{element.English500? 'Yes' : 'No'}}</div>
                    <div *ngIf="!element.English500">A non-English survey is not required.</div>
                    <div *ngIf="element.English500">
                      <div>Are 10% or more of your plan participants literate only in a non-English language?
                        {{element.English10Percent? 'Yes' : 'No'}}</div>
                      <div>Total number of plan participants who read only the same non-English language:
                        {{element.NumParticipantsMore}}</div>
                      <div>What is the non-English language? {{element.NonEnglishLanguageMore}}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="btn-toolbar pull-right">
                <button class="btn btn-primary" (click)="element.Expanded = false"> CLOSE</button>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
    <mat-paginator #paginatorBottom *ngIf='processedDistributionsLength > pageSize' (page)='pageEvent = $event; pageData($event)'
      [length]='processedDistributionsLength' [pageSize]='pageSize'></mat-paginator>
    <span *ngIf="processedDistributionsLength === 0">
      <span>There are no processed distributions.</span>
    </span>
  </div>
</div>
<gems-top-button></gems-top-button>